import React, { Component } from 'react';
import Hazard from './hazard/hazard';
import Outcome from './outcome/outcome';
import HazardOptions from './hazard-options/hazard-options';
import { TimelineLite } from 'gsap/TweenMax';
import './bootselector.css';

const TWEEN_OUT = 0.3;
const TWEEN_IN = 0.5;

class BootSelector extends Component {
    constructor(props) {
        super(props);

        this.selector = null;
        this.hazard = null;
        this.outcome = null;

        this.state = {
            hazard: null,
            option: null,
            outcome: null,
        };
    }

    clearHazard() {
        console.log('Back from Hazard Selection');

        let tl = new TimelineLite({
            onComplete: () => {
                this.setState({ hazard: null, option: null, outcome: null });
            },
        });

        tl.to(this.hazard, TWEEN_OUT, { autoAlpha: 0, display: 'none' });
        tl.fromTo(
            this.selector,
            TWEEN_IN,
            { autoAlpha: 0, display: 'none' },
            { autoAlpha: 1, display: 'block' },
            '-=0.01',
        );
    }

    clearOptions() {
        console.log('Back from Outcome');
        let tl = new TimelineLite({
            onComplete: () => {
                this.setState({ option: null, outcome: null });
            },
        });

        tl.to(this.outcome, TWEEN_OUT, { autoAlpha: 0, display: 'none' });
        tl.to(this.hazard, TWEEN_IN, { autoAlpha: 1, display: 'block' }, '-=0.01');
    }

    hazardSelect(hazard) {
        // console.log(hazard);
        this.setState({ hazard, option: null, outcome: null }, () => {
            let tl = new TimelineLite();
            tl.to(this.selector, TWEEN_OUT, { autoAlpha: 0, display: 'none' });
            tl.fromTo(
                this.hazard,
                TWEEN_IN,
                { autoAlpha: 0, display: 'none' },
                { autoAlpha: 1, display: 'block' },
                '-=0.01',
            );
        });
    }

    showOutcome(outcome) {
        this.setState({ outcome }, () => {
            let tl = new TimelineLite();
            tl.to(this.hazard, TWEEN_OUT, { autoAlpha: 0, display: 'none' });
            tl.fromTo(
                this.outcome,
                TWEEN_IN,
                { autoAlpha: 0, display: 'none' },
                { autoAlpha: 1, display: 'block' },
                '-=0.01',
            );
        });
    }

    toggleTip(bool) {
        this.setState({ showTip: bool });
    }

    render() {
        return (
            <div className={`boot-selector ${this.state.showTip ? 'tip-displaying' : ''}`}>
                <div className="cutout">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="144"
                        height="54"
                        viewBox="0 0 144 54"
                    >
                        <polygon points="0,0 72,54 144,0" fill="#f2f2f2" />
                    </svg>
                </div>

                <div ref={(selector) => (this.selector = selector)}>
                    <HazardSelector
                        data={this.props.data}
                        hazardSelect={(hazard) => this.hazardSelect(hazard)}
                    />
                </div>
                <div ref={(hazard) => (this.hazard = hazard)}>
                    {this.state.hazard && (
                        <HazardOptions
                            toggleTip={(bool) => this.toggleTip(bool)}
                            showOutcome={(outcome) => this.showOutcome(outcome)}
                            hazard={this.state.hazard}
                            back={this.clearHazard.bind(this)}
                        />
                    )}
                </div>
                <div ref={(outcome) => (this.outcome = outcome)}>
                    {this.state.outcome && (
                        <Outcome
                            toggleTip={(bool) => this.toggleTip(bool)}
                            back={this.clearOptions.bind(this)}
                            {...this.state.outcome}
                        />
                    )}
                </div>
            </div>
        );
    }
}

class HazardSelector extends Component {
    render() {
        return (
            <div className="hazard-selector">
                <div className="container">
                    <h3>What hazards are in your work environment?</h3>
                    <div className="hazards-list">
                        {this.props.data.map((obj, index) => {
                            return (
                                <Hazard
                                    key={`hazard_${index}`}
                                    data={obj}
                                    onClick={() => this.props.hazardSelect(obj)}
                                    pulse={Math.random() >= 0.8}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default BootSelector;



// WEBPACK FOOTER //
// ./src/components/bootselector.js